<template>
  <!--
    AppHeader — 데스크탑 상단 헤더 영역
    SPEC-CHINA-ADMIN-HEADER-LAYOUT-001
    REQ-LAYOUT-FE-001: 데스크탑(≥768px) 고정 상단 헤더
    REQ-LAYOUT-FE-002: role="banner" a11y
    REQ-LAYOUT-FE-003: 좌측 slot + 우측 LocaleSwitcher
    REQ-LAYOUT-FE-006: Options API 일관 유지
  -->
  <!-- @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-HEADER-LAYOUT-001 — 데스크탑 헤더 신설. LocaleSwitcher 단일 진입점(AppHeader + mobile_header 우측). -->
  <header class="app-header" role="banner">
    <div class="app-header__left">
      <!-- 좌측 slot: 빈 자리 (향후 브레드크럼/타이틀 영역) -->
      <slot />
    </div>
    <div class="app-header__right">
      <!-- 우측: LocaleSwitcher (REQ-LAYOUT-FE-003) -->
      <locale-switcher />
    </div>
  </header>
</template>

<script>
import LocaleSwitcher from '@/components/header/LocaleSwitcher.vue';

export default {
  name: 'AppHeader',
  // props에 class/style 정의 금지 — Vue 3 fallthrough attribute 활용 (feedback_vue3_fallthrough_class_prop)
  components: {
    LocaleSwitcher,
  },
};
</script>
